import React from "react";
import "./Invoice.css";

function Invoice() {
  return (
    <div className="IV-00">
      <h2 className="IV-01">Invoice List</h2>
      <div className="IV-02">
        <div className="IV-03">Invoice Number</div>
        <div className="IV-03">Client Name</div>
        <div className="IV-03">Date</div>
        <div className="IV-03">Amount</div>
        <div className="IV-03">Actions</div>
      </div>
    </div>
  );
}

export default Invoice;
